import React, { useState } from "react";
import {
  Menu, X, Phone, Mail, CheckCircle2, ArrowRight, ListFilter,
  Bell, Users, IndianRupee, TrendingUp, Sparkles, BarChart3,
  Target, UserCheck, Clock, Plus, Search, Star, Send, ChevronDown,
} from "lucide-react";

import leadImage from "../../Asset/lead.png";
import "./Leadmanagement.css";
import { submitProductEnquiry } from '../../api';
import toast, { Toaster } from "react-hot-toast";

function Leadmanagement() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  const [formData, setFormData] = useState({
    fullName: "",
    companyName: "",
    phone: "",
    email: "",
    teamSize: "1 to 5 Sales Reps",
    primaryChallenge: "Lead Leakage & Missed Follow-ups",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Toast + no alert
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation — email ya phone mein se ek zaroori
    if (!formData.email.trim() && !formData.phone.trim()) {
      toast.error("Please enter either Email or Phone number.");
      return;
    }

    try {
      const result = await submitProductEnquiry({
        name: formData.fullName,
        email: formData.email || "",
        phone: formData.phone,
        company: formData.companyName,
        product: "LeadCRM",
        message: formData.primaryChallenge,
      });

      if (result.status === "success") {
        toast.success(
          `Congratulations ${formData.fullName}! Your form is submitted successfully. We will respond to you as soon as possible.`,
          { duration: 5000 }
        );

        setFormData({
          fullName: "",
          companyName: "",
          phone: "",
          email: "",
          teamSize: "1 to 5 Sales Reps",
          primaryChallenge: "Lead Leakage & Missed Follow-ups",
        });
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong. Please try again.");
    }
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    { question: "What is Yashvitech LeadCRM software and how does it work?", answer: "Yashvitech LeadCRM is an AI-powered cloud platform that automatically captures leads from Meta Ads, Google, Website, and IndiaMART, assigns them to telecallers, and automates WhatsApp/Email follow-ups to prevent lead leakage." },
    { question: "Can I access Yashvitech LeadCRM on mobile phones or tablets?", answer: "Yes, Yashvitech LeadCRM is 100% responsive and accessible on Android, iOS, tablets, and desktop web browsers so your sales team can update lead statuses on the go." },
    { question: "How does the WhatsApp and Email automated alert system work?", answer: "When a new lead enters the system or a follow-up reminder is due, LeadCRM automatically triggers instant WhatsApp messages and Email notifications to both your sales rep and the prospective client." },
    { question: "Can Yashvitech LeadCRM integrate with Facebook Ads and Google Ads?", answer: "Yes! LeadCRM offers instant 1-click integrations with Facebook Ads, Instagram Ads, Google Lead Forms, IndiaMART, TradeIndia, and custom landing pages via Webhooks and API." },
    { question: "Can LeadCRM generate sales rep performance and ROI reports?", answer: "Absolutely. LeadCRM provides interactive dashboards showing conversion rates, telecaller response time, pipeline deal value, and source-wise ROI analytics." },
  ];

  return (
    <div className="lm-wrapper">
      {/* ✅ Toast Container */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 5000,
          style: {
            fontSize: "13px",
            borderRadius: "10px",
            maxWidth: "380px",
          },
        }}
      />

      {/* NAVBAR */}
      <header className="lm-navbar">
        <div className="lm-navbar-container">
          <a href="#home" className="lm-navbar-logo" onClick={closeMenu}>
            <div className="lm-logo-icon">Y</div>
            <div className="lm-logo-text">
              <h2>Yashvitech</h2>
              <span>LEAD MANAGEMENT SYSTEM</span>
            </div>
          </a>

          <nav className={`lm-nav-links ${menuOpen ? "lm-active" : ""}`}>
            <a href="#lm-features" onClick={closeMenu}>Key Features</a>
            <a href="#lm-demo" onClick={closeMenu}>Interactive Demo</a>
            <a href="#lm-success" onClick={closeMenu}>Success Stories</a>
            <a href="#lm-faq" onClick={closeMenu}>FAQ</a>
          </nav>

          <div className="lm-navbar-right">
            <a href="tel:+919876543210" className="lm-phone-number">
              <Phone size={18} />
              <span>+91 98765 43210</span>
            </a>
            <a href="#lm-request-demo" className="lm-demo-button">Book Free Demo</a>
          </div>

          <button className="lm-menu-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
            {menuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </header>

      {/* HERO */}
      <section id="home" className="lm-hero-wrapper">
        <div className="lm-glow-top-left" />
        <div className="lm-glow-bottom-right" />

        <div className="lm-hero-container">
          <div className="lm-hero-content">
            <div className="lm-hero-badge">
              <Sparkles className="lm-icon-badge" />
              <span>#1 Lead Management Software in India</span>
            </div>

            <h1 className="lm-hero-title">
              Supercharge Sales Pipeline & Stop Lead Leakage with{" "}
              <br className="lm-hidden-mobile" />
              <span className="lm-text-gradient">Yashvitech LeadCRM</span>
            </h1>

            <p className="lm-hero-description">
              A powerful cloud-based Lead Management System designed
              for sales teams, marketing agencies, and growing
              businesses. Seamlessly capture leads, automate
              WhatsApp follow-ups, and track conversions in one
              unified dashboard.
            </p>

            <div className="lm-features-grid">
              <div className="lm-feature-item"><CheckCircle2 className="lm-icon-check" /><span>Instant Lead Capture & Auto-Assign</span></div>
              <div className="lm-feature-item"><CheckCircle2 className="lm-icon-check" /><span>WhatsApp & Email Automation Alerts</span></div>
              <div className="lm-feature-item"><CheckCircle2 className="lm-icon-check" /><span>Follow-up Reminders & Deal Tracking</span></div>
              <div className="lm-feature-item"><CheckCircle2 className="lm-icon-check" /><span>Lead Source & ROI Analytics</span></div>
            </div>

            <div className="lm-cta-buttons">
              <a href="#lm-request-demo" className="lm-btn-primary">
                <span>Request Live Free Demo</span>
                <ArrowRight className="lm-btn-icon" />
              </a>
              <a href="#lm-features" className="lm-btn-secondary">
                <ListFilter className="lm-btn-icon-sm" />
                <span>Explore Features</span>
              </a>
            </div>

            <div className="lm-divider" />

            <div className="lm-stats-row">
              <div className="lm-stat-item"><span className="lm-stat-number">10K+</span><span className="lm-stat-label">Leads Managed</span></div>
              <div className="lm-stat-divider" />
              <div className="lm-stat-item"><span className="lm-stat-number">3x</span><span className="lm-stat-label">Sales Conversion</span></div>
              <div className="lm-stat-divider" />
              <div className="lm-stat-item"><span className="lm-stat-number">99.9%</span><span className="lm-stat-label">Uptime Guaranteed</span></div>
            </div>
          </div>

          <div className="lm-hero-mockup">
            <div className="lm-mockup-card">
              <div className="lm-image-box">
                <img src={leadImage} alt="Lead Management Dashboard" className="lm-mockup-img" />
                <div className="lm-live-tag">LIVE CRM ACTIVE</div>
              </div>

              <div className="lm-cards-grid">
                <div className="lm-info-card">
                  <div className="lm-info-header"><span>ACTIVE LEADS</span><Users className="lm-info-icon" /></div>
                  <div className="lm-info-value lm-text-amber">1,420</div>
                  <div className="lm-info-sub lm-text-emerald"><TrendingUp className="lm-sub-icon" /><span>+28.4% Conversion</span></div>
                </div>
                <div className="lm-info-card">
                  <div className="lm-info-header"><span>PIPELINE VALUE</span><IndianRupee className="lm-info-icon" /></div>
                  <div className="lm-info-value lm-text-emerald">₹ 48.5 Lakh</div>
                  <div className="lm-info-sub lm-text-muted">✓ Auto Reconciled</div>
                </div>
              </div>

              <div className="lm-alert-bar">
                <div className="lm-alert-text">
                  <Bell className="lm-alert-icon" />
                  <p className="lm-truncate"><strong className="lm-text-amber">Alert:</strong> Lead "Rohan Sharma" follow-up in 15m!</p>
                </div>
                <span className="lm-sms-tag">SMS Sent</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section id="lm-features" className="lm-features-section">
        <div className="lm-features-heading">
          <span>POWERFUL LEAD MANAGEMENT</span>
          <h2>Everything You Need to Manage<br />Your Leads Effectively</h2>
          <p>Capture, organize, track and convert leads from one simple platform.</p>
        </div>

        <div className="lm-feature-grid">
          <div className="lm-feature-card"><div className="lm-feature-icon"><Users size={27} /></div><h3>Lead Management</h3><p>Add, organize and manage all your leads from one centralized dashboard.</p></div>
          <div className="lm-feature-card"><div className="lm-feature-icon"><BarChart3 size={27} /></div><h3>Lead Tracking</h3><p>Track every lead from new inquiry to follow-up and final conversion.</p></div>
          <div className="lm-feature-card"><div className="lm-feature-icon"><Bell size={27} /></div><h3>Follow-up Reminders</h3><p>Never miss important follow-ups with reminders for calls and meetings.</p></div>
          <div className="lm-feature-card"><div className="lm-feature-icon"><Target size={27} /></div><h3>Lead Status</h3><p>Manage lead stages like New, Contacted, Qualified, Converted and Lost.</p></div>
          <div className="lm-feature-card"><div className="lm-feature-icon"><TrendingUp size={27} /></div><h3>Sales Reports</h3><p>Get useful insights about leads, conversions and team performance.</p></div>
          <div className="lm-feature-card"><div className="lm-feature-icon"><UserCheck size={27} /></div><h3>Team Management</h3><p>Assign leads to team members and monitor their activities and performance.</p></div>
        </div>
      </section>

      {/* INTERACTIVE DEMO */}
      <section id="lm-demo" className="lm-demo-section">
        <div className="lm-demo-heading">
          <span>INTERACTIVE DEMO</span>
          <h2>Manage Your Leads From One Place</h2>
          <p>See how easily your team can manage, track and convert leads.</p>
        </div>

        <div className="lm-demo-dashboard">
          <div className="lm-demo-top">
            <div><h3>Lead Dashboard</h3><span>Welcome back, Admin</span></div>
            <button className="lm-add-lead-btn"><Plus size={17} /> Add Lead</button>
          </div>

          <div className="lm-demo-stats">
            <div className="lm-demo-stat"><div className="lm-demo-stat-icon"><Users size={20} /></div><div><span>Total Leads</span><h3>248</h3><small>+12.5% this month</small></div></div>
            <div className="lm-demo-stat"><div className="lm-demo-stat-icon"><UserCheck size={20} /></div><div><span>Qualified Leads</span><h3>56</h3><small>+8.4% this month</small></div></div>
            <div className="lm-demo-stat"><div className="lm-demo-stat-icon"><Clock size={20} /></div><div><span>Follow-ups</span><h3>24</h3><small>8 due today</small></div></div>
            <div className="lm-demo-stat"><div className="lm-demo-stat-icon"><TrendingUp size={20} /></div><div><span>Converted</span><h3>32</h3><small>+15.2% this month</small></div></div>
          </div>

          <div className="lm-leads-box">
            <div className="lm-leads-header">
              <h3>Recent Leads</h3>
              <div className="lm-search-box">
                <Search size={16} />
                <input type="text" placeholder="Search leads..." />
              </div>
            </div>

            <div className="lm-lead-table">
              <div className="lm-table-head">
                <span>Lead Name</span><span>Company</span><span>Status</span><span>Source</span><span>Assigned To</span>
              </div>
              <div className="lm-table-row">
                <div className="lm-lead-name"><div className="lm-lead-avatar">A</div><span>Aditya Sharma</span></div>
                <span>Tech Solutions</span><span className="lm-status lm-new">New</span><span>Website</span><span>Rahul</span>
              </div>
              <div className="lm-table-row">
                <div className="lm-lead-name"><div className="lm-lead-avatar">P</div><span>Priya Mehta</span></div>
                <span>Digital World</span><span className="lm-status lm-contacted">Contacted</span><span>Facebook</span><span>Amit</span>
              </div>
              <div className="lm-table-row">
                <div className="lm-lead-name"><div className="lm-lead-avatar">R</div><span>Rahul Verma</span></div>
                <span>Growth Labs</span><span className="lm-status lm-qualified">Qualified</span><span>Google Ads</span><span>Neha</span>
              </div>
              <div className="lm-table-row">
                <div className="lm-lead-name"><div className="lm-lead-avatar">S</div><span>Sneha Kapoor</span></div>
                <span>Smart Systems</span><span className="lm-status lm-converted">Converted</span><span>Referral</span><span>Rahul</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SUCCESS STORIES */}
      <section id="lm-success" className="lm-success-section">
        <div className="lm-success-heading">
          <span>SUCCESS STORIES</span>
          <h2>What Our Customers Say</h2>
          <p>Trusted by teams who want to manage leads better and grow faster.</p>
        </div>

        <div className="lm-review-cards">
          <div className="lm-review-card">
            <div className="lm-stars"><Star size={17} fill="currentColor" /><Star size={17} fill="currentColor" /><Star size={17} fill="currentColor" /><Star size={17} fill="currentColor" /><Star size={17} fill="currentColor" /></div>
            <p>"Yashvitech has made lead management much easier for our team. We can track every lead and follow-up without missing anything."</p>
            <div className="lm-review-user"><div className="lm-review-avatar">A</div><div><h3>Aditya Sharma</h3><span>Sales Manager</span></div></div>
          </div>
          <div className="lm-review-card">
            <div className="lm-stars"><Star size={17} fill="currentColor" /><Star size={17} fill="currentColor" /><Star size={17} fill="currentColor" /><Star size={17} fill="currentColor" /><Star size={17} fill="currentColor" /></div>
            <p>"The dashboard gives us a clear view of our sales pipeline. Our team responds faster and we are converting more leads."</p>
            <div className="lm-review-user"><div className="lm-review-avatar">P</div><div><h3>Priya Mehta</h3><span>Business Owner</span></div></div>
          </div>
          <div className="lm-review-card">
            <div className="lm-stars"><Star size={17} fill="currentColor" /><Star size={17} fill="currentColor" /><Star size={17} fill="currentColor" /><Star size={17} fill="currentColor" /><Star size={17} fill="currentColor" /></div>
            <p>"Simple, clean and easy to use. Assigning leads to team members and checking their progress is now very simple."</p>
            <div className="lm-review-user"><div className="lm-review-avatar">R</div><div><h3>Rahul Verma</h3><span>Sales Executive</span></div></div>
          </div>
        </div>
      </section>

      {/* REQUEST DEMO */}
      <section className="lm-request-demo-section" id="lm-request-demo">
        <div className="lm-demo-glow-left" />
        <div className="lm-demo-glow-right" />

        <div className="lm-demo-container">
          <div className="lm-demo-content">
            <div className="lm-demo-badge">
              <Sparkles size={14} className="lm-badge-icon" />
              <span>FREE PERSONALIZED DEMO</span>
            </div>

            <h2 className="lm-demo-title">Ready to Automate Your Sales &amp; Multiply Pipeline Growth?</h2>

            <p className="lm-demo-description">
              Schedule a 15-minute live demo with our Lead Management System specialists.
              We will show you how Yashvitech LeadCRM can fit your exact team size and sales workflow.
            </p>

            <div className="lm-demo-checklist">
              <div className="lm-check-item"><CheckCircle2 className="lm-check-icon" /><span>Zero Setup Fee &amp; Dedicated Onboarding Manager</span></div>
              <div className="lm-check-item"><CheckCircle2 className="lm-check-icon" /><span>Instant Data Import from Excel / Tally / Old CRM</span></div>
              <div className="lm-check-item"><CheckCircle2 className="lm-check-icon" /><span>1-on-1 Personalized Walkthrough &amp; Custom Setup</span></div>
            </div>
          </div>

          <div className="lm-demo-card">
            <div className="lm-form-header">
              <h3 className="lm-form-title">Request Your Free LeadCRM Demo</h3>
              <p className="lm-form-subtitle">Fill in your details below. Our team will contact you within 15 minutes.</p>
            </div>

            <form className="lm-demo-form" onSubmit={handleSubmit}>
              <div className="lm-form-grid">
                <div className="lm-input-group">
                  <label>FULL NAME *</label>
                  <input type="text" name="fullName" placeholder="e.g. Ramesh Shah" required value={formData.fullName} onChange={handleChange} />
                </div>

                <div className="lm-input-group">
                  <label>COMPANY / FIRM NAME *</label>
                  <input type="text" name="companyName" placeholder="e.g. Shah Solutions" required value={formData.companyName} onChange={handleChange} />
                </div>

                <div className="lm-input-group">
                  <label>PHONE NUMBER (WHATSAPP)</label>
                  <input type="tel" name="phone" placeholder="+91 98765 43210" value={formData.phone} onChange={handleChange} />
                </div>

                <div className="lm-input-group">
                  <label>BUSINESS EMAIL</label>
                  <input type="email" name="email" placeholder="ramesh@shahsolutions.com" value={formData.email} onChange={handleChange} />
                </div>

                <div className="lm-input-group">
                  <label>SALES TEAM SIZE</label>
                  <select name="teamSize" value={formData.teamSize} onChange={handleChange}>
                    <option value="1 to 5 Sales Reps">1 to 5 Sales Reps</option>
                    <option value="6 to 20 Sales Reps">6 to 20 Sales Reps</option>
                    <option value="20+ Sales Reps">20+ Sales Reps</option>
                  </select>
                </div>

                <div className="lm-input-group">
                  <label>PRIMARY CHALLENGE</label>
                  <select name="primaryChallenge" value={formData.primaryChallenge} onChange={handleChange}>
                    <option value="Lead Leakage & Missed Follow-ups">Lead Leakage &amp; Missed Follow-ups</option>
                    <option value="WhatsApp Automation">WhatsApp Automation</option>
                    <option value="Manual Excel Tracking">Manual Excel Tracking</option>
                    <option value="Team Performance Tracking">Team Performance Tracking</option>
                  </select>
                </div>
              </div>

              <button type="submit" className="lm-submit-btn">
                <span>Submit &amp; Book My Demo</span>
                <Send size={18} />
              </button>

              <small style={{ display: "block", textAlign: "center", fontSize: "11px", color: "#94a3b8", marginTop: "10px" }}>
                Enter at least one — Email or Phone — so we can reach you back.
              </small>
            </form>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="lm-faq-section" id="lm-faq">
        <div className="lm-faq-container">
          <div className="lm-faq-header">
            <span className="lm-faq-badge">FREQUENTLY ASKED QUESTIONS</span>
            <h2 className="lm-faq-title">Got Questions? We've Got Answers.</h2>
            <p className="lm-faq-subtitle">Everything you need to know about Yashvitech LeadCRM software and integrations.</p>
          </div>

          <div className="lm-faq-list">
            {faqs.map((faq, index) => (
              <div key={index} className={`lm-faq-item ${activeIndex === index ? "lm-active" : ""}`}>
                <button className="lm-faq-question" onClick={() => toggleFAQ(index)} aria-expanded={activeIndex === index}>
                  <span>{faq.question}</span>
                  <ChevronDown className={`lm-faq-icon ${activeIndex === index ? "lm-rotate" : ""}`} />
                </button>
                <div className="lm-faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="lm-footer">
        <div className="lm-footer-container">
          <div className="lm-footer-brand">
            <a href="#home" className="lm-footer-logo">
              <div className="lm-logo-icon">Y</div>
              <div className="lm-logo-text">
                <h2>Yashvitech</h2>
                <span>LEAD MANAGEMENT SYSTEM</span>
              </div>
            </a>
            <p>Smart and simple Lead Management System designed to help businesses capture, manage and convert leads efficiently.</p>
          </div>

          <div className="lm-footer-column">
            <h3>Quick Links</h3>
            <a href="#home">Home</a>
            <a href="#lm-features">Features</a>
            <a href="#lm-demo">Interactive Demo</a>
            <a href="#lm-success">Success Stories</a>
            <a href="#lm-faq">FAQ</a>
          </div>

          <div className="lm-footer-column">
            <h3>Product</h3>
            <a href="#lm-features">Lead Management</a>
            <a href="#lm-features">Lead Tracking</a>
            <a href="#lm-features">Follow-up Reminders</a>
            <a href="#lm-features">Sales Reports</a>
            <a href="#lm-features">Team Management</a>
          </div>

          <div className="lm-footer-contact">
            <h3>Contact Us</h3>
            <a href="tel:+919876543210"><Phone size={17} /><span>+91 98765 43210</span></a>
            <a href="mailto:info@yashvitech.com"><Mail size={17} /><span>info@yashvitech.com</span></a>
          </div>
        </div>

        <div className="lm-footer-bottom">
          <p>© 2026 Yashvitech. All rights reserved.</p>
          <p>Lead Management System</p>
        </div>
      </footer>
    </div>
  );
}

export default Leadmanagement;